import React from 'react';
import PropTypes from 'prop-types';

import LinkHeader from './linkHeader';
import { INTEGRATIONS_PATH } from '../constants';

const MailchimpIntegrationOutlet = ({ baseUrl, children }) => (
  <div className="mailchimp-integration">
    <LinkHeader heading="Integrate Mailchimp" label="Cancel" link={`${baseUrl}${INTEGRATIONS_PATH}`} />
    {children}
  </div>
);

MailchimpIntegrationOutlet.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  children: PropTypes.node,
};

MailchimpIntegrationOutlet.defaultProps = {
  children: null,
};

export default MailchimpIntegrationOutlet;
